import React from 'react';
import { Route } from 'react-router-dom';
import { ACCESS_MANAGEMENT_PATH } from './paths';
import AccessManagement from 'modules/AccessManagement/AccessManagement';
export default function AccessManagementRoutes() {
  return /*#__PURE__*/React.createElement(Route, {
    path: ACCESS_MANAGEMENT_PATH,
    exact: true
  }, /*#__PURE__*/React.createElement(AccessManagement, null));
}